import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import CategoriesSection from '@/pages/home/components/CategoriesSection';
import SeoContent from '@/pages/home/components/SeoContent';
import ArticleCards from '@/pages/home/components/ArticleCards';
import GuideSection from '@/pages/home/components/GuideSection';
import Footer from '@/pages/home/components/Footer';
import { WebsiteSchema, OrganizationSchema } from '@/components/base/SchemaOrg';

export default function Home() {
  return (
    <main>
      <WebsiteSchema />
      <OrganizationSchema />
      <Navbar />
      <Hero />
      <CategoriesSection />
      <ArticleCards />
      <SeoContent />
      <GuideSection />
      <Footer />
    </main>
  );
}